import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { AdornedInput, Adornment, Input } from '@zillow/constellation';
import PropTypes from 'prop-types';
import withLabel from './withLabel.js';
import jsxRuntime from '../../node_modules/react/jsx-runtime.js';

var _excluded = ["disabled", "error", "leftAdornment", "rightAdornment", "name", "register", "registerProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var InputField = function InputField(_ref) {
  var disabled = _ref.disabled,
    error = _ref.error,
    leftAdornment = _ref.leftAdornment,
    rightAdornment = _ref.rightAdornment,
    name = _ref.name,
    register = _ref.register,
    registerProps = _ref.registerProps,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsx(AdornedInput, {
    inputId: props.id || name,
    disabled: disabled,
    error: !!error,
    leftAdornment: leftAdornment && /*#__PURE__*/jsxRuntime.jsx(Adornment, {
      children: leftAdornment
    }),
    rightAdornment: rightAdornment && /*#__PURE__*/jsxRuntime.jsx(Adornment, {
      children: rightAdornment
    }),
    input: /*#__PURE__*/jsxRuntime.jsx(Input, _objectSpread(_objectSpread({}, props), register(name, registerProps)))
  });
};
InputField.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  leftAdornment: PropTypes.node,
  rightAdornment: PropTypes.node,
  error: PropTypes.object,
  register: PropTypes.func,
  registerProps: PropTypes.object
};
InputField.defaultProps = {
  registerProps: {},
  register: function register() {}
};
var LabeledInputField = withLabel(InputField);
var LabeledInputField$1 = LabeledInputField;

export { LabeledInputField$1 as default };
//# sourceMappingURL=LabeledInputField.js.map
